import { render, staticRenderFns } from "./taxasComercialVert.vue?vue&type=template&id=09865d16&scoped=true"
import script from "./taxasComercialVert.vue?vue&type=script&lang=js"
export * from "./taxasComercialVert.vue?vue&type=script&lang=js"
import style0 from "./taxasComercialVert.vue?vue&type=style&index=0&id=09865d16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09865d16",
  null
  
)

export default component.exports